import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppInsightsService } from './app-insights.service';
import {AppService} from './app.service';

@Injectable({
    providedIn: 'root',
})

export class DLScannerService {

    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) {

    }
    private baseURL = this.appService.config.apiBaseUrl;
    getDLScannerSettings(facilityId: number,): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/store/GetDLScannerSettings?facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const facilityDLScannerSettings = res.body as any;
                    return facilityDLScannerSettings;
                }),
                catchError(this.handleError)
            );
    }

    startScanSession(baseURL,guid): Observable<any> {
        const apiUrl = baseURL + guid;
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post<any>(apiUrl, null, { headers, observe: 'response' });
    }

    closeScanSession(baseURL,guid): Observable<any> {
        const apiUrl = baseURL + guid;
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        // var statusCode;
        return this.http.delete<any>(apiUrl, { headers, observe: 'response' });
    }

    startDAPService(baseURL,guid): Observable<any> {
        let httpOptions: HttpHeaders = new HttpHeaders();
        httpOptions = httpOptions.append('Content-Type', 'application/json');
        const apiUrl = baseURL + guid +"/startservice";
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post<any>(apiUrl, null, { headers, observe: 'response' });
    }

    getReaderInfo(baseURL,guid,deviceName) {
        let httpOptions: HttpHeaders = new HttpHeaders();
        httpOptions = httpOptions.append('Content-Type', 'application/json');
       return this.http.get(
            `${baseURL}${guid}/readers?readerName=${deviceName}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const Details = res.body;
                    return Details;
                }),
                catchError(this.handleError)
            );
    }

    getDocumentInfo(baseURL,guid) {
        let httpOptions: HttpHeaders = new HttpHeaders();
        httpOptions = httpOptions.append('Content-Type', 'application/json');
        return this.http.get(
            `${baseURL}${guid}/document`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const Details = res.body;
                    return Details;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
    
    private handleHttpPostError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error);
            return of(result as T);
        };
    }

}
